<template>
  <expansion-panel
    :readonly="isLoading || !relatedAssetContainers?.length"
    :is-disabled="isLoading || !relatedAssetContainers?.length">
    <template #title>Asset Details</template>
    <template #header-right>
      <span class="typography-body-sm" v-if="!relatedAssetContainers?.length">
        No related assets
      </span>
    </template>
    <template #content>
      <div
        v-for="assetContainer in relatedAssetContainers"
        :key="assetContainer.id"
        class="d-flex flex-column gap-4">
        <div>
          <key-value-list>
            <key-value label="Appointment type">
              <template #value>{{ getAppointmentType(assetContainer) }}</template>
            </key-value>
          </key-value-list>
          <yard-view-asset-container-form-data
            :triggers="triggers"
            :is-editable="false"
            :warehouse="appointment.dock.warehouse"
            :asset-container="assetContainer" />
        </div>
      </div>
    </template>
  </expansion-panel>
</template>
<script>
import { defineComponent, ref, onMounted, onBeforeUnmount } from 'vue';
import { useCustomForms, useEventHub } from '@/composables';

import YardViewAssetContainerFormData from '@/modules/yard/components/AssetContainer/YardViewAssetContainerFormData.vue';
import ExpansionPanel from '@/components/elements/ExpansionPanel.vue';
import KeyValueList from '@satellite/components/elements/key_value/KeyValueList.vue';
import KeyValue from '@satellite/components/elements/key_value/KeyValue.vue';

export default defineComponent({
  name: 'AppointmentDetailsGateYardYard',
  components: {
    YardViewAssetContainerFormData,
    ExpansionPanel,
    KeyValueList,
    KeyValue
  },
  props: {
    appointment: {
      type: Object,
      required: true
    },
    triggers: {
      type: Array,
      required: true
    }
  },
  setup(props) {
    const isLoading = ref(false);
    const relatedAssetContainers = ref([]);
    const eventHub = useEventHub();

    const { getAppointmentRelatedAssetContainers } = useCustomForms();

    const getAppointmentType = assetContainer => {
      if (assetContainer.dropAppointmentId && assetContainer.pickupAppointmentId) {
        return 'Drop & Hook';
      }

      if (assetContainer.dropAppointmentId) {
        return 'Dropoff';
      }

      if (assetContainer.pickupAppointmentId) {
        return 'Pickup';
      }

      return 'Unknown';
    };

    const fetchAssetContainerData = async () => {
      isLoading.value = true;
      try {
        relatedAssetContainers.value = await getAppointmentRelatedAssetContainers(
          props.appointment.id
        );
      } catch (error) {
        console.error('Error fetching related asset containers:', error);
      } finally {
        isLoading.value = false;
      }
    };

    onMounted(async () => {
      await fetchAssetContainerData();

      eventHub.$on('update-AssetContainer', event => {
        if (
          event.dropAppointmentId === props.appointment.id ||
          event.pickupAppointmentId === props.appointment.id
        ) {
          fetchAssetContainerData();
        }
      });
    });
    onBeforeUnmount(() => {
      eventHub.$off('update-AssetContainer');
    });

    return {
      isLoading,
      relatedAssetContainers,
      getAppointmentType
    };
  }
});
</script>
